import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import Organizations, { ORGANIZATION_TABS } from "~/pages/organizations"

export const Route = createFileRoute("/_auth/internal/customer-management/_layout/organizations")({
  validateSearch: z.object({
    org: z.string().optional(),
    tab: z.enum(ORGANIZATION_TABS).optional().catch(undefined),
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { org, tab } = Route.useSearch()
  return <Organizations key={org} selectedOrgIdFromSearch={org} tabFromSearch={tab} />
}
